module.exports = __webpack_public_path__ + "img/1f9c5.36e7530.svg";